import { StatsElementDto } from '../interfaces/StatsElementDto';
import { StatsElementFilterInternalName } from '../enums/StatsElementGridFilterName';
import { initialStatsElementData } from './initialStatsElementData';

export const initialStatsElementDto: StatsElementDto = {
  [StatsElementFilterInternalName.Default]: initialStatsElementData,
};
